import QueryLine from '@/components/query2/query-line';

export default {
    props: {
        /**
         * @type {QueryLine}
         */
        item: QueryLine,
        /**
         * @type {{}}
         */
        validate: Object,
    },
    computed: {
        isCustomField() {
            return this.item.isCustomField;
        },
        hasEntities() {
            return !!(this.item.config && this.item.config.options);
        },
        isSelectingList() {
            return this.item.isSelectingList && !this.isEmpty;
        },
        isEmpty() {
            return this.item.isEmpty;
        },
    },
    data() {
        return {
            isLoading: false,
            values: this.decodeData(this.item.getValues()),
        };
    },
    methods: {
        /**
         * Identity method for defining how data is loaded for the initial state.
         * @param {string|[]} data
         * @return {*}
         */
        decodeData(data) {
            return data;
        },
        /**
         * Identity method for defining how data is compiled to be saved in the state.
         * @param {string|[]} data
         * @return {*}
         */
        encodeData(data) {
            return data;
        },
        dispatchUpdate(data) {
            this.$emit('update', this.encodeData(data));
        },
    },
};
